import React from 'react';
import { useParams,Route, Switch } from 'react-router-dom';

import { List } from './List';
import { AdminCompartment } from './AdminCompartment';
import { Reassign } from './Reassign';


function Kiosks({ match }) {
    const { path } = match;
    let { venue } = useParams();

    return (
        
        <Switch>
            <Route exact path={path} component={List} />
            <Route path={`${path}/edit/:id`} component={AdminCompartment} />
            <Route path={`${path}/reassign/:id`} component={Reassign} />
            <Route path={`${path}/:venue`} component={List} />
        </Switch>

    );
}

export { Kiosks };